// extracted by mini-css-extract-plugin
module.exports = {"container":"EventCalendarHint_container__bVObo","text":"EventCalendarHint_text__cBjl_"};